<template>
  <div>
    <base-confirm-dialog-extended
      v-if="title"
      :show="show"
      :title="title"
      :message="message"
      :positive-text="positiveText || undefined"
      :negative-text="negativeText || undefined"
      :reverse="reverse"
      :show-options="showOptions"
      :class="customClass"
      :show-cancel="showCancel"
      :show-close-button="showCloseButton"
      @cancelled="handleEvent(false)"
      @confirmed="handleEvent(true)"
      @closed="reset"
    />
    <base-confirm-dialog
      v-else
      :show="show"
      :message="message"
      :positive-text="positiveText || undefined"
      :negative-text="negativeText || undefined"
      :reverse="reverse"
      :show-cancel="showCancel"
      :show-close-button="showCloseButton"
      :class="customClass"
      @cancelled="handleEvent(false)"
      @confirmed="handleEvent(true)"
      @closed="reset"
    />
  </div>
</template>
<script>
import { EventBus } from '@/event-bus';

export default {
  name: 'BaseConfirmDialogContainer',
  data() {
    return {
      show: false,
      title: null,
      message: '',
      callback: null,
      positiveText: null,
      negativeText: null,
      reverse: false,
      showOptions: true,
      showCancel: true,
      showCloseButton: true,
      customClass: '',
    };
  },
  mounted() {
    EventBus.$on('confirm', this.open);
  },
  methods: {
    reset() {
      this.message = '';
      this.callback = null;
      this.positiveText = null;
      this.negativeText = null;
      this.reverse = false;
      this.showOptions = true;
    },
    handleEvent(confirm) {
      this.show = false;
      if (this.callback) {
        this.callback(confirm);
      }
    },
    open({
      title,
      message,
      callback,
      positiveText,
      negativeText,
      reverse,
      showOptions,
      showCancel = null,
      showCloseButton = null,
      customClass = null,
    }) {
      this.title = title || null;
      this.message = message || '';
      this.callback = callback || null;
      this.positiveText = positiveText || null;
      this.negativeText = negativeText || null;
      this.reverse = reverse || false;
      this.show = true;
      this.showOptions = showOptions;
      this.showCancel = showCancel !== null ? showCancel : this.showCancel;
      this.showCloseButton = showCloseButton !== null ? showCloseButton : this.showCloseButton;
      this.customClass = customClass;
    },
  },
};
</script>
<style lang="scss"
  scoped>
</style>
